<template>
  <div class="date-interval-picker-section">
    <el-row >
      <el-col align="middle" :xs="24" :sm="24" :md="12">
        <el-popover
          placement="bottom-start"
          :visible-arrow="false"
          trigger="click"
          v-on:show="currentIcon = 'el-icon-arrow-up'"
          v-on:hide="currentIcon = 'el-icon-arrow-down'"
          popper-class="date-interval-picker-popover"
          ref="popover"
        >
          <date-picker
            :value="dateInterval"
            @input="dateChange"
            :label="$t('date_interval_picker.start_end_date')"
            :setMinDate="false"
            :shortcutsEnabled="true"
            :disabledDate="disabledDate"
            :enabledAction="enabledAction"
          />
          <div class="actions">
            <tertiary-button
              @click.native="handleCancelClick"
            >
              {{ $t('date_interval_picker.cancel') }}
            </tertiary-button>
          </div>
          <el-button slot="reference">
            <img src="@/assets/images/month-icon.svg" />
            {{ timelineLabel }}
            <i :class="currentIcon" />
          </el-button>
        </el-popover>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" align="middle">
        <div class="scope-selectors" v-if="showScope">
          <el-radio-group v-model="internalScope" :disabled="!enabledAction" style="margin-bottom: 30px;">
            <el-radio-button label="daily">{{$t('date_picker.daily')}}</el-radio-button>
            <el-radio-button label="weekly">{{$t('date_picker.weekly')}}</el-radio-button>
            <el-radio-button label="monthly">{{$t('date_picker.monthly')}}</el-radio-button>
          </el-radio-group>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import DatePicker from '@/components/common/DatePicker'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import { format, toDate, startOfMonth } from 'date-fns'
  export default {
    components: {
      DatePicker,
      TertiaryButton
    },
    props: {
      startDate: {
        default: () => startOfMonth(Date.now())
      },
      endDate: {
        default: () => toDate(Date.now())
      },
      scope: {
        default: 'daily'
      },
      timelineLabel:{},
      showScope: {
        type: Boolean,
        default: true
      },
      enabledAction: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        internalScope: 'daily',
        internalStartDate: null,
        internalEndDate: null,
        currentIcon: 'el-icon-arrow-down',
      }
    },
    methods: {
      dateChange(value) {
        this.internalStartDate = value.start
        this.internalEndDate = value.end;
        this.handleEffectDateChange();
      },
      handleEffectDateChange() {
        // const formatedStartDate = format(new Date(this.internalStartDate), 'dd MMM yyyy', {locale: locale_mapping[this.$i18n.locale]})
        // const formatedEndDate = format(new Date(this.internalEndDate), 'dd MMM yyyy', {locale: locale_mapping[this.$i18n.locale]})
        // this.internalTimelineLabel = `${formatedStartDate} - ${formatedEndDate}`
        this.$emit('updatedDate', {
          startDate: this.internalStartDate,
          endDate: this.internalEndDate,
          // timelineLabel: this.internalTimelineLabel
        })
        this.$refs.popover.doClose();
        this.resetAllChartData()
      },
      resetAllChartData() {
        this.$store.dispatch('classes/resetExportLessonData')
        this.$store.dispatch('classes/resetExportAssessmentData')
        this.$store.dispatch('classes/resetExportLessonDetailData')
        this.$store.dispatch('classes/resetEpsChart')
        this.$store.dispatch('classes/resetLessonStudysetPracticeChart')
        this.$store.dispatch('organization/resetOverview')
        this.$store.dispatch('organization/resetEpsChart')
        this.$store.dispatch('organization/resetLessonStudysetPracticeChart')
        this.$store.dispatch('organization/resetAvgPracticeTimeChart')
        this.$store.dispatch('organization/resetActiveStudentChart')
        this.$store.dispatch('organization/resetWeeklyStudentChart')
      },
      handleCancelClick() {
        this.$refs.popover.doClose()
      },
      disabledDate(time) {
        var currDate = new Date();
        currDate.setDate(currDate.getDate() + 1);
        return time.getTime() > currDate;
      }
    },
    computed: {
      dateInterval() {
        return {
          start: this.internalStartDate,
          end: this.internalEndDate
        }
      }
    },
    watch: {
      startDate: {
        immediate: true,
        handler(newValue) {
          this.internalStartDate = newValue
        }
      },
      endDate: {
        immediate: true,
        handler(newValue) {
          this.internalEndDate = newValue
        }
      },
      scope(newValue) {
        this.scope = newValue
      },
      internalScope(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.$emit('update:scope', newValue);
          this.resetAllChartData();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .date-interval-picker-section {
    text-align: end;
    display: flex;
    flex-direction: row;
    align-items: center;

    .scope-selectors {
      padding-left: 15px;
      min-width: 270px;
      ::v-deep .el-radio-group {
        margin-bottom: 0px !important;
      }
    }
  }

  button {
    border: 2px solid #B558FF;
    border-radius: 4px;
    font-weight: 700;
    font-size: 14px;
    text-transform: capitalize;
    color: #B558FF;
    padding: 11px 16px;
    &:hover, &:focus {
      background-color: #B558FF;
      color: white;
      border-color: #B558FF;
    }
    i {
      margin-left: 16px;
    }
    img {
      vertical-align: bottom;
      margin-right: 11px;
    }
  }
  .actions {
    margin-top: 48px;
    text-align: right;
    .elsa-button {
      min-width: auto;
    }
    .elsa-primary-button {
      width: 144px;
    }
    .elsa-flat-button.el-button {
      padding: 0;
      width: 60px;
      border: none;
    }
  }

  @media only screen and (max-width: 768px) {
    .scope-selectors{
      padding-left: 0px !important;
      padding-top: 15px;
    }
  }

</style>
